module.exports = __webpack_public_path__ + "img/ketchup.c2835a11.webp";